<template>
  <div>
    <div class="row d-flex flex-column align-items-center">
      <button class="cusmtom-dropdown-buttom" type="button" @click="toggle">
        <div>
          <i
            class="fas fa-angle-down color-yellow-star float-left mt-3 h2 pl-4"
          />
          <span>Seleccione</span>
        </div>
      </button>
      <div v-if="open" class="cusmtom-dropdown-container">
        <div
          v-for="(service, idx) in services"
          :key="`service-${idx}`"
          class="col-md-3"
        >
          <div
            v-if="userHasPermissions(service.permissionName)"
            class="col col-sm col-12 mb-4"
          >
            <service-badge :service="service" @selected="onSelect(idx)" />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <div
          v-for="(service, idx) in selectedServices"
          :key="`service-${idx}`"
          class="col-md-3"
        >
          <div id="badge-selected" class="col col-sm col-12 mb-4">
            <service-badge :service="service" />
          </div>
        </div>
      </div>
      <div class="col-12 d-flex flex-grow-1 justify-content-center">
        <span class="d-block font-14 mt-3">
          <em class="far fa-info-circle mr-2 color-yellow-star font-18" />
          Puede seleccionar más de un (1) servicio.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { ServiceBadge } from 'provisional-remedy';

export default {
  name: 'DropDownSelectServices',
  components: {
    ServiceBadge,
  },
  props: {
    open: {
      type: Boolean,
      default: () => false,
    },
    services: {
      type: Array,
      default: () => [],
    },
    selectedServices: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    toggle() {
      this.$emit('show-dropdown', !this.open);
    },
    onSelect(idx) {
      this.$emit('on-select', idx);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.cusmtom-dropdown-buttom {
  border-radius: 57px;
  height: 70px;
  line-height: 50px;
  color: map-get($colors, 'black');
  font-family: Arial;
  width: 490px;
  max-width: 100%;
  font-size: 16px;
  background-color: map-get($colors, 'white');
  border: solid map-get($colors, 'gray-8') 1px;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  box-shadow: 0 0.5rem 1rem rgb(0, 0, 0.15);
}

.cusmtom-dropdown-container {
  margin-top: 0.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: map-get($colors, 'white');
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.5rem;
  padding-top: 1rem;
  width: 73%;
  box-shadow: 0 0.5rem 1rem rgb(0, 0, 0.15);
  animation: myAnim 1s ease 0s 1 normal forwards;
}

@keyframes myAnim {
  0% {
    transform: scaleY(0.4);
    transform-origin: 100% 0%;
  }

  100% {
    transform: scaleY(1);
    transform-origin: 100% 0%;
  }
}
</style>
